import React from 'react'
import { FlexContainer } from '../../layouts'
import { P, Chip } from '../../components'

export interface IGroupCapabilitiesList {
  capabilities: Array<{ id: string; title?: string }>
}

export const GroupCapabilitiesList = ({
  capabilities: [first, second, ...rest],
}: IGroupCapabilitiesList) => (
  <FlexContainer wrap="true">
    {[first, second].filter(Boolean).map(({ id, title }) => (
      <Chip key={id} label={title} />
    ))}
    {!!rest.length && <P>and {rest.length} more…</P>}
  </FlexContainer>
)
